import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "profile-section" }
const _hoisted_3 = { class: "summary-section summary" }
const _hoisted_4 = { class: "summary-group" }
const _hoisted_5 = ["name"]
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "summary-group" }
const _hoisted_9 = ["name"]
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "details-wrapper" }

import { ref, computed } from "vue";
import { CertificationVM } from "@/types/certifications";
import SlideTransition from "@/components/shared/SlideTransition.vue";
import Details from "@/components/v2/certifications/Details.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    certification: {}
  },
  setup(__props: any) {

const props = __props;

const detailsVisible = ref<boolean>(false);

const summaryLeft = computed(() => {
  return [
    {
      name: "lender",
      label: "Lender",
      value: props.certification?.header.lenderName ?? "",
    },
    {
      name: "ncherId",
      label: "NCHER ID",
      value: props.certification?.header?.ncherCode,
    },
    {
      name: "programNameAbbr",
      label: "Program",
      value: props.certification?.header?.programName,
    },
    {
      name: "programAltCode",
      label: "ALT Code",
      value: props.certification?.header?.programAltCode,
    },
  ];
});

const summaryRight = computed(() => {
  return [
    {
      name: "loanAmount",
      label: "Loan Amount",
      value: props.certification?.header?.loanAmountDisplay,
    },
    {
      name: "totalDisbursedAmount",
      label: "Total Disb. Amount",
      value: props.certification?.header?.totalDisbursedAmountDisplay,
      title: "Total Disbursed Amount",
    },
  ];
});

function toggleDetails() {
  detailsVisible.value = !detailsVisible.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.certification?.borrowers?.borrower?.fullName || ""), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryLeft.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "summary-item",
              name: item.name
            }, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(item.label), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(item.value), 1)
            ], 8, _hoisted_5))
          }), 128))
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "divider" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryRight.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "summary-item",
              name: item.name
            }, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(item.label), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(item.value), 1)
            ], 8, _hoisted_9))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        onClick: toggleDetails,
        class: "toggle-button"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(
          detailsVisible.value
            ? 'arrow-up icon-up-open-big'
            : 'arrow-down icon-down-open-big'
        )
        }, null, 2)
      ]),
      _createVNode(SlideTransition, { "is-visible": detailsVisible.value }, {
        default: _withCtx(() => [
          _createVNode(Details, { certification: __props.certification }, null, 8, ["certification"])
        ]),
        _: 1
      }, 8, ["is-visible"])
    ])
  ], 64))
}
}

})